import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedSolanaWallet } from '@/networks/svm';

const HeaderWalletDrawerSolanaWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedSolanaWallet {...props} />;
};

export default HeaderWalletDrawerSolanaWalletConnect;
